import { type RadarAddress } from '@garnish/location';

/**
 * Returns a formatted location address that does not include the country term.
 *
 * Does NOT include the apt / unit number since Radar does not return it with autocomplete
 */
export const withoutCountryTerm = (addressPrediction: RadarAddress) => {
  const { number, street, city, stateCode } = addressPrediction;

  const streetPart = [number, street].filter(Boolean).join(' ');
  const parts = [streetPart, city, stateCode].filter(Boolean);

  return parts.join(', ');
};
